export enum ReferenceTypeConstants {
  INTERNAL_REFERENCE = 'Internal',
  ISIN = 'ISIN',
  MORNINGSTAR_ID = 'MorningstarID',
  RIC = 'RIC',
  TICKER = 'Ticker',
  SEDOL = 'SEDOL',
}
